import script from "./VLink.vue?vue&type=script&setup=true&lang=js"
export * from "./VLink.vue?vue&type=script&setup=true&lang=js"

import "./VLink.vue?vue&type=style&index=0&id=1b916edd&lang=css"

const __exports__ = script;

export default __exports__